import { Stack } from '@mui/material';
import CTAButton from '../../ui/ctaButton';
import { Gapper } from '../../ui/utils';
import {
  HeroContainer,
  HeroOverHeading,
  HeroHeading,
  HeroSubHeading,
  HeroSubtext,
  HeroTextWrapper,
  ExternalText,
} from './styles';

const HeroSection = ({
  overHeading,
  heading,
  subHeading,
  subtext,
  externalText,
  containedButtonText,
  outlinedButtonText,
  onContainedButtonClick,
  onOutlinedButtonClick,
  // The hero headline is the page's <h1>. `variant` still drives the styling,
  // so only the tag changes; pass headingComponent to opt out where a page
  // already declares its <h1> elsewhere.
  headingComponent = 'h1',
  children,
}) => {
  const handleContainedButtonClick = () => {
    onContainedButtonClick && onContainedButtonClick();
  };
  const handleOutlinedButtonClick = () => {
    onOutlinedButtonClick && onOutlinedButtonClick();
  };
  return (
    <HeroContainer>
      <HeroTextWrapper>
        {overHeading && <HeroOverHeading variant="overline">{overHeading}</HeroOverHeading>}
        {heading && (
          <HeroHeading variant="h3" component={headingComponent}>
            {heading}
          </HeroHeading>
        )}
        {subHeading && <HeroSubHeading variant="h4">{subHeading}</HeroSubHeading>}
        {subtext && <HeroSubtext variant="body1">{subtext}</HeroSubtext>}
        {children && children}
      </HeroTextWrapper>

      <Gapper gap={containedButtonText || outlinedButtonText ? 25 : 0}>
        {(containedButtonText || outlinedButtonText) && (
          <Stack direction="row" justifyContent="center" gap={2.5}>
            {containedButtonText && (
              <CTAButton
                variant="contained"
                text={containedButtonText}
                onClick={handleContainedButtonClick}
              />
            )}
            {outlinedButtonText && (
              <CTAButton
                variant="outlined"
                text={outlinedButtonText}
                onClick={handleOutlinedButtonClick}
              />
            )}
          </Stack>
        )}
        {externalText && <ExternalText variant="body1">{externalText}</ExternalText>}
      </Gapper>
    </HeroContainer>
  );
};

export default HeroSection;
